export default "__VITE_ASSET__Bhtxachc__"